import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavController, NavParams, LoadingController, ModalController, ActionSheetController, ToastController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { ImagePipe } from 'src/app/pipes/image/image';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
@Component({
  selector: 'app-grupo-participantes-presenca',
  templateUrl: './grupo-participantes-presenca.page.html',
  styleUrls: ['./grupo-participantes-presenca.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    SemRegistroComponent
  ],
})
export class GrupoParticipantesPresencaPage implements OnInit {
  idReuniao: string = '';
  participantes: any = [];
  readOnly: boolean = false;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public grupoProvider: GrupoProvider,
    public loadingController: LoadingController,
    public modalCtrl: ModalController,
    public actionSheetCtrl: ActionSheetController,
    public toastCtrl: ToastController,
    private translate: TranslateService
  ) {
    this.idReuniao = this.navParams.get('idReuniao');
    this.readOnly = this.navParams.get('readOnly');
    this.grupoProvider.getParticipantes(this.idReuniao).subscribe((data) => {
      this.participantes = data;
    });
  }

  ngOnInit() {
  }

  salvar() {
    let data = { idProjeto: this.idReuniao, tipo: '1', pessoas: this.participantes };
    this.grupoProvider.salvarParticipantes(data).subscribe(async () => {

      const toast = await this.toastCtrl.create({
        message: this.translate.instant('Lista de presença atualizada com sucesso!'),
        duration: 3000
      });

      toast.present();
      this.modalCtrl.dismiss();
    });
  }

  salvarIndividual(presenca: { presenca: string; }) {
    presenca.presenca = presenca.presenca == '0' ? '1' : '0';
    let data = { idProjeto: this.idReuniao, tipo: '1', pessoa: presenca };
    this.grupoProvider.salvarParticipante(data).subscribe(async () => {

      const toast = await this.toastCtrl.create({
        message: this.translate.instant('Presença salva com sucesso!'),
        duration: 3000
      });
      toast.dismiss();
      // toast.dismissAll();
      toast.present();
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  proximo() {
    this.modalCtrl.dismiss(true);
  }
}
